import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-code-audit")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-code-audit")),
  head: () => ({
    meta: [
      { title: "سجلّ تغييرات أكواد السفراء — Lecmo Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
